exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image[data-v-56521098] {\n  width: 50px;\n  height: 50px;\n  border: none;\n}\n.ml10[data-v-56521098] {\n  margin-left: 10px;\n}\n", ""]);

// exports
